import React, {useState} from "react";
import {Tooltip} from "reactstrap";
import './iconTooltip.scss'
import AppLink from "../AppLink";

export function IconTooltip({link, id, icon, tooltipMessage, style, className}) {
  const [tooltip, setTooltip] = useState(false);
  const DirectionToggle = () => setTooltip(!tooltip);

  function iconContent() {
    return (
      <>
        <span className={'icon-container ' + className} id={`Tooltip-${tooltipMessage}-${id}`} style={style}>
        <i
          onClick={() => {
          }}
          className={icon}
        ></i></span>
        <Tooltip
          placement={'bottom'}
          isOpen={tooltip}
          target={`Tooltip-${tooltipMessage}-${id}`}
          toggle={DirectionToggle}
        >
          {tooltipMessage}
        </Tooltip>
      </>
    )
  }

  return link ?
    <AppLink to={`${link}`}>
      {iconContent()}
    </AppLink> :
    <a style={{cursor:'pointer'}} onClick={e=>e.preventDefault()}>{iconContent()}</a>


}
